module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "createpoint"
  }, [_c('div', {
    staticClass: "banner_wrapper"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": ">"
    }
  }, [_c('el-breadcrumb-item', [_vm._v("会员功能")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/main/memberredpoint'
      },
      "replace": ""
    }
  }, [_vm._v("会员集点")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v("创建集点")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "myform_wrapper"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "myRate",
    attrs: {
      "rules": _vm.formrules,
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "目标点数"
    }
  }, [_c('el-form-item', {
    attrs: {
      "prop": "exchange_pt"
    }
  }, [_c('el-rate', {
    attrs: {
      "max": 10,
      "show-text": "",
      "void-icon-class": "el-rate-off",
      "icon-classes": ['el-rate-on', 'el-rate-on', 'el-rate-on'],
      "texts": _vm.textList,
      "text-color": "#FE9B20"
    },
    model: {
      value: (_vm.form.exchange_pt),
      callback: function($$v) {
        _vm.$set(_vm.form, "exchange_pt", $$v)
      },
      expression: "form.exchange_pt"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "gray-explain"
  }, [_vm._v("* 大数据分析表明，选择5点可使回头客明显增加，活动效果更优！")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "集点条件"
    }
  }, [_c('span', [_vm._v("支付满")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "obtain_amt"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "type": "number"
    },
    model: {
      value: (_vm.form.obtain_amt),
      callback: function($$v) {
        _vm.$set(_vm.form, "obtain_amt", _vm._n($$v))
      },
      expression: "form.obtain_amt"
    }
  })], 1), _vm._v(" "), _c('span', [_vm._v("元可集一个点")])], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "explain",
    attrs: {
      "prop": "checked"
    }
  }, [_c('el-checkbox', {
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("一次付款可以集多点")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("适合有顾客批量购买多个商品的情况")]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_vm._v("例如：支付20元可集一点，当用户微信支付80元时，可以直接集4点")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "礼品名称",
      "prop": "goods_name"
    }
  }, [_c('el-input', {
    staticClass: "panel-select-input-220",
    attrs: {
      "size": "small",
      "type": "text"
    },
    model: {
      value: (_vm.form.goods_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "goods_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.goods_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "礼品价格",
      "prop": "goods_amt"
    }
  }, [_c('el-input', {
    staticClass: "panel-select-input-220",
    attrs: {
      "size": "small",
      "type": "text"
    },
    model: {
      value: (_vm.form.goods_amt),
      callback: function($$v) {
        _vm.$set(_vm.form, "goods_amt", _vm._n($$v))
      },
      expression: "form.goods_amt"
    }
  }), _vm._v(" "), _c('span', [_vm._v("元")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "开始时间",
      "prop": "start_time"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "请选择开始时间",
      "size": "small",
      "editable": false,
      "clearable": false,
      "picker-options": _vm.dateRange
    },
    model: {
      value: (_vm.form.start_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "start_time", $$v)
      },
      expression: "form.start_time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "结束时间",
      "prop": "expire_time"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "placeholder": "请选结束时间",
      "size": "small",
      "editable": false,
      "clearable": false,
      "picker-options": _vm.dateRange
    },
    model: {
      value: (_vm.form.expire_time),
      callback: function($$v) {
        _vm.$set(_vm.form, "expire_time", $$v)
      },
      expression: "form.expire_time"
    }
  })], 1), _vm._v(" "), (!_vm.role.single) ? _c('el-form-item', {
    attrs: {
      "prop": "mchnt_id_list",
      "label": "适用门店"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择门店",
      "multiple": "",
      "filterable": "",
      "size": "small"
    },
    model: {
      value: (_vm.form.mchnt_id_list),
      callback: function($$v) {
        _vm.$set(_vm.form, "mchnt_id_list", $$v)
      },
      expression: "form.mchnt_id_list"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "全部",
      "value": "",
      "disabled": _vm.state
    }
  }), _vm._v(" "), _vm._l((_vm.shopData), function(shop) {
    return _c('el-option', {
      key: shop.uid,
      attrs: {
        "label": shop.shopname,
        "value": shop.uid,
        "disabled": shop.state == 0
      }
    })
  })], 2)], 1) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-submit_wrapper"
  }, [_c('span', {
    staticClass: "cancel",
    on: {
      "click": _vm.cancelCreat
    }
  }, [_vm._v("放弃创建")]), _vm._v(" "), _c('div', {
    staticClass: "panel-btn__download panel-btn__download_detail",
    on: {
      "click": _vm.preview
    }
  }, [_c('i', {
    staticClass: "icon-create"
  }), _vm._v(" "), _c('span', [_vm._v("提交预览")])]), _vm._v(" "), _c('span', {
    staticClass: "black-explain"
  }, [_vm._v("注：会员在集点满额兑换礼品后，将自动重新集点")])])], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header panel-header__fix"
  }, [_c('div', {
    staticClass: "panel-select-group"
  }, [_c('span', {
    staticClass: "panel-header__desc"
  }, [_vm._v("输入集点信息")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2af50455"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/createpoint/createpoint.vue
// module id = 801
// module chunks = 1